module.exports = __webpack_public_path__ + "static/media/patek-food-banner@2x.accab162.png";